import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../../actions/projectManagerActions';
import ProjectManagerForm from '../Identifiers/locationProjectManagerForm';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import { getNullableOnChangeValue } from '../../../helpers/multiselect';

export class ProjectManager extends React.Component {

    constructor(props, context) {
        super(props, context);

        const newProjectManager = {
            id: 0,
            name: "",
            isActive: true,
            subscriptionId: props.subscriptionId
        };

        this.state = {
            projectManagers: [],
            totalCount: 0,
            isFetching: false,
            isSaving: false,
            selectedProjectManager: newProjectManager,
            editProjectManager: newProjectManager,
            newProjectManager: newProjectManager,
            drawerOpen: false,
            isFormValid: true,
            errorMessage: "",
            searchParams: {
                subscriptionId: props.subscriptionId,
                isActive: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: ""
            }
        };
        this.search.bind(this);
    }

    async componentDidMount() {
        await this.search();
    }

    async search() {
        try {
            this.setState({ isFetching: true });
            const result = await this.props.actions.searchProjectManagers(this.state.searchParams);
            const payload = result.payload;
            if (result.type === types.SEARCH_PROJECTMANAGER_SUCCESS) {
                this.setState({ projectManagers: payload.results, totalCount: payload.totalCount });
            } else if (result.type === types.SEARCH_PROJECTMANAGER_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isFetching: false });
        }
    }

    async save() {
        try {
            this.setState({ isSaving: true });
            const result = await this.props.actions.saveProjectManager(this.state.editProjectManager)

            if (result.type === types.CREATE_PROJECTMANAGER_SUCCESS || result.type === types.UPDATE_PROJECTMANAGER_SUCCESS) {
                Notification("success", "Save Successful", "Project Manager saved successfully")
                this.setState({ drawerOpen: false });
                this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
                    this.search();
                });
            } else if (result.type === types.UPDATE_PROJECTMANAGER_FAILURE || result.type === types.CREATE_PROJECTMANAGER_FAILURE) {
                this.setState({ errorMessage: result.payload.message });
                Notification("error", "An Error Occurred", result.payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isSaving: false });
        }

    }

    filterNameChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, name: e.target.value } });
    }

    keyUpName = (e) => {
        if (e.keyCode == 13) {
            this.search();
        }
    }

    onSearchBlur = () => {
        this.search();
    }

    onActiveChange = (e) => {
        const selectedValue = getNullableOnChangeValue(e);
    
        this.setState(prevState => ({
            searchParams: {
                ...prevState.searchParams,
                isActive: selectedValue
            }
        }), () => {
            this.search();
        });
    }

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: (e.page + 1) } }, () => {
            this.search();
        });
    }

    onAddNew = () => {
        this.setState({ selectedProjectManager: null, editProjectManager: this.state.newProjectManager, drawerOpen: true, errorMessage: "", isFormValid: true });
    }

    onFormChange = (name, value) => {
        this.setState({ editProjectManager: { ...this.state.editProjectManager, [name]: value } });
    }

    // ------- Drawer
    saveClick = () => {

        if (this.state.editProjectManager.name.trim().length < 1) {
            this.setState({ isFormValid: false });
            return;
        }
        this.setState({ isFormValid: true });
        this.save();
    }

    cancelClick = () => {
        this.setState({ drawerOpen: false });
    }

    selectProjectManager = (e) => {
        const newValue = e.value || this.state.selectedProjectManager;
        this.setState({ selectedProjectManager: newValue, editProjectManager: newValue, drawerOpen: true, errorMessage: "", isFormValid: true });
    }
    // ------- Drawer

    actionTemplate = (rowData) => {
        if (rowData.isActive) {
            return <div className="text-success text-center"><Icon name="check-circle" /></div>;
        } else {
            return <div className="text-danger text-center"><Icon name="times-circle" /></div>;
        }
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState({
                searchParams: {
                    ...this.state.searchParams,
                    sortBy: sortBy,
                    sortDir: sortDir
                }
            }, this.search);
        }
    }

    render() {

        const activeOptions = [
            { label: "Yes", value: true },
            { label: "No", value: false },
            { label: "All", value: null }
        ];
        
        const activeFilter = (
                            <Dropdown
                                className="ui-column-filter"
                                value={this.state.searchParams.isActive}
                                options={activeOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.onActiveChange}
                                placeholder="Select an option"
                            />
                        );

        const nameFilterElement =
            <input type="text" className="p-inputtext" placeholder="Filter by Name" size="50" onBlur={this.onSearchBlur} onChange={this.filterNameChange} onKeyUp={this.keyUpName} value={this.state.searchParams.name} />
        ;

        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                {this.state.drawerOpen ?
                    <Drawer isWide={false} title="Project Manager" onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
                        <ProjectManagerForm
                            projectManager={this.state.editProjectManager}
                            onFormChange={this.onFormChange}
                            isFormValid={this.state.isFormValid}
                            onSubmit={this.saveClick} />
                    </Drawer>                
                :
                ""
                }

                <LoadingIndicator isLoading={this.state.isFetching || this.state.isSaving} hideWhileLoading={true}>
                    <div>
                        <div className="identifier-header">
                            <div className="title">Project Manager</div>
                            <div className="close">
                                <button type="button" onClick={this.props.onClose} alt="close popup"><Icon name="times" /></button>
                            </div>
                        </div>

                        <div className="identifier-add-new">
                            <div className="col-sm-12">
                                <button type="button" className="btn btn-primary" onClick={this.onAddNew} alt="close popup"><span className="me-2">Add New</span><Icon name="plus-circle" /></button>
                            </div>
                        </div>

                        <div className="identifier-results-table">
                            <DataTable
                                filterDisplay="row"
                                className="p-datatable-sm p-datatable-striped"
                                value={this.state.projectManagers}
                                selectionMode="single"
                                selection={this.state.selectedProjectManager}
                                onSelectionChange={this.selectProjectManager}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                onSort={this.onSort}
                                >
                                <Column field="name" header="Name" sortable={true} filter={true} filterElement={nameFilterElement} />
                                <Column field="isActive" header="Active" sortable={true} body={this.actionTemplate} style={{ width: '120px' }} filter={true} filterElement={activeFilter} />
                            </DataTable>
                            {
                                this.state.totalCount > this.state.searchParams.pageSize &&
                                <Paginator
                                    rows={this.state.searchParams.pageSize}
                                    totalRecords={this.state.totalCount}
                                    first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                    onPageChange={this.onPageChange} />
                            }
                            <div className="results-count">Total records: {this.state.totalCount}</div>
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }

}

ProjectManager.propTypes = {
    subscriptionId: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(ProjectManager);

